export default __webpack_public_path__ + "static/media/20_mobile.e5c9fe2d.jpg";